(ns ui.hidden-features
  "Features that are live but not shown to everyone yet, on the client:
   the sidebar entry of a dark-launched page appears once the person
   has run `storrito.showHiddenFeatures()` in the browser console
   (`app.hidden-features` sets the cookie `storrito-hidden-features`).
   The page itself stays reachable by its URL."
  (:require [clojure.string :as str]))

(def cookie-name
  "storrito-hidden-features")

(defn cookie-shown?
  "Whether a `document.cookie` string carries the switch."
  [cookie-string]
  (boolean
    (some (fn [pair]
            (let [[k v] (str/split (str/trim pair) #"=" 2)]
              (and (= cookie-name k) (= "show" (str/trim (str v))))))
          (str/split (str cookie-string) #";"))))

(defn shown?
  "Whether the hidden features are shown in this browser. Always false
   on the server, which renders the public sidebar."
  []
  #?(:cljs (cookie-shown? (.-cookie js/document))
     :clj false))
